const BASE_URL = "https://api.makemybrand.ai";


let requests = {};
window.addEventListener("message", (event) => {
  if (event.source !== window || !event.data || event.data.origin !== "EXTENSION") return;

  const response = event.data.content;
  if (response?.id in requests) {
    try {  
      let decoded = atob(response.result?.body); // base64 decode 
      decoded = JSON.parse(decoded);
      console.log("response", decoded);
      if (!decoded.errors) {
        requests[response.id].resolve(decoded);
      } else {
        requests[response.id].reject(decoded);
      }
    } catch (error) {
      console.error("Error in decoding response", error);
      requests[response.id].reject(error);
    }
    delete requests[response.id];
  }
});

export function sendToWindow(type, requestData) {
  const requestId = Math.random().toString(36);
  requests[requestId] = {
    resolve: null,
    reject: null
  };
  requestData.timeout_timestamp = new Date().getTime() + 1000 * 60 * 5;
  window.postMessage({
      origin: "WEBPAGE",
      content: {
        type: type,
        requestData,
        requestId
      }
  }, "*");


  setTimeout(() => {
    if (requestId in requests) {
      requests[requestId].reject("Timeout");
      delete requests[requestId];
    }
  }, 1000 * 60); // 1 minute

  return new Promise((resolve, reject) => {
    requests[requestId] = {
      resolve: resolve,
      reject: reject
    };
  });
}



export const poll = async ({task_id}) => {
  let pollCount = 0;
  return new Promise((resolve, reject) => {
      function pollInside() {
          pollCount++;
          if (pollCount > 50) {
              reject({error: 'Polling limit exceeded'});
              return;
          }
          req('/poll', 'POST', JSON.stringify({ task_id })).then(res => {
              const stat = res.status?.toLowerCase();
              if (stat !== 'failed' && stat !== 'success' && stat != "completed") { // todo you can remove completed
                  setTimeout(pollInside, 10000);
              } else if (stat == 'completed' || stat == "success") { // todo you can remove completed
                  resolve(res.result);
              } else {
                  reject(res.result);
              }
          }).catch(reject);
      }
      // setTimeout(() => pollInside, 10000);
      pollInside();
  });
}
export function reqPoll(path, method = "GET", bodyData, json = true) {
  return req(path, method, bodyData, json).then(poll);
}
export function req(path, method = "GET", bodyData, json = true, baseUrl = BASE_URL) {
  const opts = {
    method,
    credentials: "include",
    headers: {}
  };
  const token = localStorage.getItem("mmb_token");
  if (token) {
    opts.headers["Authorization"] = `Bearer ${token}`;
  }
  
  if (bodyData) {
    opts.body = bodyData;
  }
  if (json) {
    opts.headers["Content-Type"] = "application/json";
  }
  const url = baseUrl + path;
  return fetch(url, opts).then((response) => {
    return response.json().then((data) => {
      if (data.error) {
        return Promise.reject(data.error);
      }
      if (response.status !== 200 && response.status !== 201 && response.status !== 204) {
        return Promise.reject(data.message);
      }
      return data;
    });
  });
}


export function toErrorMessage(error) {
  if (error?.message == 'UNAVAILABLE_PREMIUM_TEMPLATE') {
    return 'Please upgrade to premium to use this template.';
  }
  if (error?.message == 'TEMPLATE_NOT_FOUND') {
    return 'This template is not available.';
  }
  if (error?.message == 'PURCHASE_PLAN') {
    return 'Please purchase a plan to use this feature.';
  }
  if (error?.error) {
    return error.error;
  }
  return 'An error occurred. Please try again later.';
}